/* eslint-disable max-statements */
/* eslint-disable max-lines-per-function */

import { type IdTyping, type RangeSliderValueTyping } from '@shared/typings';
import { type Ref } from 'vue';

// eslint-disable-next-line max-lines-per-function, max-statements
export const useWidgetBusinessStore = defineStore('business', () => {
    // State
    const selectedDate: Ref<string> = ref('');
    const selectedTimeRange: Ref<RangeSliderValueTyping> = ref({
        min: '09:00',
        max: '17:00',
    });
    const guestAmount: Ref<number | undefined> = ref(undefined);
    const spaceIds: Ref<IdTyping[]> = ref([]);
    const productIds: Ref<IdTyping[]> = ref([]);

    // Actions
    const resetBusinessStore = (): void => {
        selectedDate.value = '';
        guestAmount.value = undefined;
        selectedTimeRange.value = {
            min: '09:00',
            max: '17:00',
        };
        spaceIds.value = [];
        productIds.value = [];
    };

    return {
        // State
        selectedDate,
        selectedTimeRange,
        guestAmount,
        spaceIds,
        productIds,

        // Actions
        resetBusinessStore,
    };
});
